<!--
 @description 数据字典配置页
 @date 2018/11/22
-->
<template>
  <div class="dataDicConfig__content">
    <g-back :history="history"></g-back>
    <el-form ref="searchForm" :model="searchForm" :inline="true" label-width="0" input-width="auto">
      <el-form-item>
        <el-input v-model="searchForm.tableName" :placeholder="$t('dataDictionary.tableName')"></el-input>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" 
          @click="search(true)" 
          v-g-rac="gRac('dataDicConfig_search')" 
          v-text="$t('common.search')"></el-button>
      </el-form-item>
    </el-form>
    <div style="margin-bottom: 16px;">
      <el-button type="primary" 
        @click="addTable" 
        v-g-rac="gRac('dataDicConfig_add')" 
        v-text="$t('common.add')"></el-button>
    </div>
    <el-table-extend
      :data="tableData"
      :head="tableHead"
      :currentChange="currentChange"
      :sizeChange="sizeChange"
      border>
      <template slot="control-column" slot-scope="{data}">
        <el-table-extend-control 
          :control="tableControl" 
          :data="data" 
          :label="$t('dataDictionary.table.operate')">
        </el-table-extend-control>
      </template>
    </el-table-extend>
    <dialog-form
      id="dicCfgDiaForm"
      :title="dicCfgDiaTitle"
      :visible.sync="dialogDiaVis" 
      :model="dialogForm"
      :input-data="dialogData"
      :rules="dialogFormRule"
      :confirm-fun="dialogConfirm">
    </dialog-form>
  </div>
</template>
  
<script>
  import dialogForm from '@/components/dialogForm'

  import rac from '@/plugins/rac-mixin'
  import dataDictionaryBiz from '@/logic/cmdb/dataDictionaryBiz'
  import validateConfig from '@/utils/validate'
  export default {
    mixins: [rac],
    data () {
      return {
        history: [],
        searchForm: {
          tableName: ''
        },
        tableData: {},
        tableHead: [],
        currentPage: 1,
        perPageCount: 10,
        dicCfgDiaTitle: this.$t('dataDictionary.addTable'),
        dialogDiaVis: false,
        dialogForm: {
          tableName: '',
          tableDesc: ''
        },
        dialogData: [{
          label: this.$t('dataDictionary.tableName'),
          key: 'tableName'
        }, {
          label: this.$t('dataDictionary.desc'),
          key: 'tableDesc'
        }],
        dialogFormRule: {
          tableName: [{ ...validateConfig.common.notEmpty }]
        },
        tableControl: [{
          rac: () => this.gRac('dataDicConfig_delete'),
          label: this.$t('common.delete'),
          callback: (row, index, data) => {
            this.$confirm(this.$t('common.deleteTips'), this.$t('common.delete'), {
              confirmButtonText: this.$t('common.confirm'),
              cancelButtonText: this.$t('common.cancel'),
              type: 'warning'
            }).then(() => {
              dataDictionaryBiz.deleteTable({ id: row.id }).then(() => {
                this.handleSuccess()
              })
            }).catch(() => {})
          }
        }, {
          rac: () => this.gRac('dataDicConfig_amend'),
          label: this.$t('common.edit'),
          callback: (row, index, data) => {
            this.dialogForm.tableName = row.tableName
            this.dialogForm.tableDesc = row.tableDesc
            this.selectId = row.id
            this.isEdit = true
            this.dialogDiaVis = true
          }
        }, {
          rac: () => this.gRac('dataDictionary_check'),
          label: this.$t('common.check'),
          callback: (row, index, data) => {
            this.$router.push({
              name: 'dataDicProperty',
              query: {
                id: this.$route.query.id,
                tableId: row.id,
                database: this.$route.query.database,
                tableName: row.tableName
              }
            })
          }
        }],
        isEdit: false,
        selectId: ''
      }
    },
    components: {
      dialogForm
    },
    methods: {
      setHisotry () {
        this.history = []
        this.history.push({ name: this.$route.query.database })
      },
      initTable () {
        this.tableHead = [
          { key: 'tableName', label: this.$t('dataDictionary.connectTableHead.tableName') },
          { key: 'tableDesc', label: this.$t('dataDictionary.connectTableHead.tableDesc') }
        ]
      },
      search (fromClick = false) {
        if (fromClick) {
          this.currentPage = 1
          this.perPageCount = 10
        }
        this.initTable()
        let searchObj = {
          currentPage: this.currentPage,
          perPageCount: this.perPageCount,
          parentId: this.$route.query.id
        }
        if (this.searchForm.tableName) {
          searchObj.tableName = this.searchForm.tableName
        }
        dataDictionaryBiz.getTable(searchObj).then((data) => {
          this.tableData = data
        })
      },
      addTable () {
        this.dialogForm.tableName = ''
        this.dialogForm.tableDesc = ''
        this.isEdit = false
        this.dialogDiaVis = true
      },
      currentChange (val) {
        this.currentPage = val
        this.search()
      },
      sizeChange (val) {
        this.currentPage = 1
        this.perPageCount = val
        this.search()
      },
      dialogConfirm (formInfo) {
        formInfo.parentId = this.$route.query.id
        if (this.isEdit) {
          formInfo.id = this.selectId
          dataDictionaryBiz.updateTable(formInfo).then(() => {
            this.handleSuccess()
            this.dialogDiaVis = false
          })
        } else {
          dataDictionaryBiz.saveTable(formInfo).then(() => {
            this.handleSuccess()
            this.dialogDiaVis = false
          })
        }
      },
      handleSuccess () {
        this.$message({
          message: this.$t('common.success'),
          type: 'success'
        })
        this.search()
      }
    },
    watch: {
      $route (to, from) {
        if (to.name === 'dataDicConfig' && from.name === 'dataDictionary') {
          this.searchForm.tableName = ''
          this.setHisotry()
          this.search()
        } else if (to.name === 'dataDicConfig' && from.name === 'dataDicProperty') {
          this.search()
        }
      },
      isEdit (val) {
        this.dicCfgDiaTitle = val ? this.$t('dataDictionary.amendTable') : this.$t('dataDictionary.addTable')
      }
    },
    mounted () {
      this.setHisotry()
      this.search()
    }
  }
</script>

<style scoped>
</style>